import {
  convertHotelGuestsToFerryPassengers,
  passengersToParams,
} from './utils'
import { omit } from 'lodash'

const paths = {
  stay: '/accommodation',
  attractions: '/attractions',
  ferry: '/crossings/departure',
}

const keys = {
  journeyType: 'tripType',
  ferryId: 'ferryIds',
}

const handleSubmit = (values, options = {}) => {
  const pathname = paths[values.activeTab] || '/crossings/departure'
  const params = new URLSearchParams()

  //  passengers
  const passengerParams =
    values.activeTab === 'stay'
      ? passengersToParams({
          departure: convertHotelGuestsToFerryPassengers({
            rooms: values.hotelGuests,
          }),
          return: convertHotelGuestsToFerryPassengers({
            rooms: values.hotelGuests,
          }),
        })
      : passengersToParams(values.passengers)

  if (values.activeTab === 'stay' && values.hotelGuests?.length) {
    const roomParams = values.hotelGuests
      .map(room => `${room.adults}|${room.children}`)
      ?.join(',')

    params.append('rooms', roomParams)
  }

  Object.entries(passengerParams)
    .filter(
      param =>
        param[0] !==
        (values.journeyType === 'oneWay' ? 'returnPassengers' : ''),
    )
    .forEach(param => params.append(param[0], param[1]))

  Object.entries(
    omit(values || {}, ['activeTab', 'passengers', 'hotelGuests']),
  ).forEach(([key, val]) => {
    const paramKey = keys[key] || key

    params.append(paramKey, `${val}`)
  })

  Object.entries(omit(options || {}, ['submitInNewWindow'])).forEach(
    ([key, val]) => {
      if (val) {
        params.append(key, `${val}`)
      }
    },
  )

  if (pathname === '/crossings/departure' && values?.ferryId !== 'rj') {
    params.append('showVehicleSelection', 'true')
  }

  const target = `${
    process.env.REACT_APP_BOOKING_URL
  }${pathname}?${params.toString()}`

  if (options?.submitInNewWindow) {
    window.open(target)
    return
  }

  window.location = target
}
export default handleSubmit
